import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  SimpleGrid,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { PaginationInterface } from "../../constants/Pagination";
import { ResellerInterface } from "../../constants/ResellerProfile";
import useCustomToast from "../../lib/useCustomToast";
import { axiosPublic } from "../../utils/AxiosInstance";
import { ModalTitle } from "../card/ModalTitle";
import { PickResellerCard } from "../card/PickResellerCard";
import SearchInput from "../input/SearchInput";
import Pagination from "../Pagination";
import { CardSkeleton } from "../skeleton/CardSkeleton";

const ResellersModal = ({
  onClose,
  isOpen,
  productSlug,
}: {
  onClose: () => void;
  isOpen: boolean;
  productSlug: string;
}) => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const [pagination, setPagination] = useState<PaginationInterface | undefined>(
    undefined
  );
  const [data, setData] = useState<ResellerInterface[] | undefined>(undefined);
  const [page, setPage] = useState<number>(1);
  const [search, setSearch] = useState<string>("");
  const toast = useCustomToast();

  useEffect(() => {
    if (isOpen) {
      setData(undefined);
      setLoaded(false);

      axiosPublic
        .get(
          `/v1/landing/product-list-store/${productSlug}?search=${search}&page=${page}`
        )
        .then((res) => {
          setData(res.data.data.products);
          setPagination(res.data.data.paginator);
        })
        .catch((err) => {
          toast({
            description: err?.response?.data?.message || "",
          });
        })
        .finally(() => {
          setLoaded(true);
        });
    }
  }, [isOpen, page, productSlug, search]);

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      isCentered
      size={["lg", null, "xl", "2xl"]}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody>
          <VStack w={"100%"}>
            <ModalTitle
              title="Toko Reseller"
              subtitle="Pilih toko reseller yang Anda inginkan untuk bertransaksi lebih
            lanjut"
            />

            <SearchInput
              w={"full"}
              onConfirm={(inputValue) => {
                setSearch(inputValue);
              }}
            />

            {!loaded ? (
              <CardSkeleton row={2} column={2} height={40} mt={4} />
            ) : (
              <SimpleGrid w={"100%"} mt={4} columns={2} gap={4}>
                {data &&
                  data.map((reseller, index) => (
                    <PickResellerCard
                      key={reseller.id}
                      src={reseller.logo}
                      name={reseller.name}
                      slug={productSlug}
                      prefix={reseller.prefix}
                      onClose={onClose}
                    />
                  ))}
              </SimpleGrid>
            )}
          </VStack>
        </ModalBody>
        <ModalFooter>
          {loaded && pagination && data && data?.length > 0 && (
            <Pagination
              mt={4}
              totalItems={pagination.total}
              pageSize={pagination.per_page}
              onPageChange={(page) => {
                setPage(page);
              }}
            />
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ResellersModal;
